import React from 'react';

import { Modal } from 'src/components/common';
import { InviteEmployersUnderPeoModalContent } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { InviteEmployersUnderPeoModalArgs } from './types';

export const InviteEmployersUnderPeoModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<InviteEmployersUnderPeoModalArgs>(ModalId.InviteEmployersUnderPeo);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Add Employers"
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InviteEmployersUnderPeoModalContent
        peoId={args?.peoId}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
